module.exports = __webpack_public_path__ + "img/eth-address-input.f1a636a7.png";